import { DesktopStateKeys } from './constants';

export function getDeepLinkData(state) {
  return state.desktopApp.getIn([DesktopStateKeys.DEEP_LINK_PATH]);
}

export function getSourcePath(state) {
  return state.desktopApp.getIn([DesktopStateKeys.SOURCE_PATH]);
}
